export default {"src":"/_next/static/media/plus.44e2b613.svg","height":12,"width":12,"blurWidth":0,"blurHeight":0};